import { useAuth, USER_ROLE } from "contexts/auth/auth.context";
import { Navigate } from "react-router";

interface Props {
    children: React.ReactNode;
}

export const PatientOrGuestRoute = ({ children }: Props) => {
    const { isAuthenticated, getRole } = useAuth();
    const role = getRole();

    // If user is not logged in, allow access
    if (!isAuthenticated) {
        return <>{children}</>;
    }

    // If user is a patient, allow access
    if (role === USER_ROLE.ROLE_PATIENT) {
        return <>{children}</>;
    }

    // Otherwise, redirect to login or somewhere else
    return <Navigate to="/login" replace />;
};
